var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"file-select"},[_c('div',{staticClass:"select-button",on:{"click":function($event){_vm.geolocate()}}},[_c('span',[_vm._v("Your latitude: "+_vm._s(_vm.lat))]),_c('span',[_vm._v("Your longitude: "+_vm._s(_vm.lng))])])])}
var staticRenderFns = []

export { render, staticRenderFns }